/**
 * KOSIMA (2026-10-07): swap the footer's upright logo for the rotated full-width banner whenever
 * the upright logo would wrap onto its own row. See the "Footer logo" note in assets/kosima.css.
 *
 * Measured, not a breakpoint, because whether the block row fits depends on its content (newsletter
 * copy, link text, font size). The check removes .footer--logo-banner, reads the layout and sets the
 * class again in the same frame, so nothing paints in between: the logo counts as wrapped when its
 * block is hidden (below 1000px, md-max:hidden) or sits lower than the first block in the row.
 */
(() => {
  const update = (footer) => {
    const list = footer.querySelector('.footer__block-list');
    const logo = footer.querySelector('.footer__block--image');
    if (!list || !logo) return;

    footer.classList.remove('footer--logo-banner');
    const first = list.querySelector('.footer__block');
    const wrapped = logo.offsetParent === null || (first && logo.offsetTop > first.offsetTop + 1);
    footer.classList.toggle('footer--logo-banner', wrapped);
  };

  const init = () => {
    document.querySelectorAll('.footer').forEach((footer) => {
      if (footer.__kosimaLogoObserved) return;
      footer.__kosimaLogoObserved = true;

      let lastWidth = -1;
      new ResizeObserver(([entry]) => {
        const width = Math.round(entry.contentRect.width);
        if (width === lastWidth) return; // the class toggle changes height only; ignore that
        lastWidth = width;
        update(footer);
      }).observe(footer);

      // Web fonts change link and newsletter widths after first layout.
      if (document.fonts) document.fonts.ready.then(() => update(footer));
    });
  };

  init();
  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', init);
})();
